import Vue from 'vue'
import Router from 'vue-router'

import home from '../modules/home/router'
import account from '../modules/account/router'
import user from '../modules/user/router'
import department from '../modules/department/router'
import httpStatusCode from '../modules/httpStatusCode/router'
import wxtp from '../modules/wxtp/router'
import callCustomer from '../modules/callCustomer/router.js'
import callStatistics from '../modules/callStatistics/router.js'
import callRecordPhone from '../modules/callRecordPhone/router.js'
import callWorkTask from '../modules/callWorkTask/router'
import callTask from '../modules/callTask/router'
import callTag from '../modules/callTag/router'
import callNumberUsedRecord from '../modules/callNumberUsedRecord/router'

import kefu from '../modules/kefu/router'

let aRouters = [].concat(account, user, department, httpStatusCode,
    wxtp, callCustomer, callStatistics, callRecordPhone, callWorkTask, callTask, callTag, callNumberUsedRecord, kefu);
Vue.use(Router);

//企业微信router
import workOutCustomerRecordDetail from '../modules/work/outCustomerRecordDetail/router'
import workStatistics from '../modules/work/workStatistics/router'
import workOutCustomer from '../modules/work/outCustomer/router'
import workOutSenstiveWord from '../modules/work/outSensitiveWord/router'
import workOutSenstiveWordRecord from '../modules/work/outSensitiveWordRecord/router'
import workIpRecordPhone from '../modules/work/IpPhoneRecord/router'
import workOutCustomerRecord from '../modules/work/outCustomerRecord/router'
import workOutCustomerAnalysis from '../modules/work/outCustomerAnalysis/router'

let bRouters = [].concat(workOutCustomerRecordDetail, workOutCustomer, workStatistics,
    workOutSenstiveWord, workOutSenstiveWordRecord, workIpRecordPhone, workOutCustomerRecord,
    workOutCustomerAnalysis);

export default new Router({
    mode: 'history',
    routes: home.concat(aRouters, bRouters)
})



// WEBPACK FOOTER //
// ./src/router/index.js